import React, { useState, useEffect } from 'react';
import { parse } from 'query-string';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { Head, PromocodeProvider } from '@dom/components';

import { guidePaymentSuccess, porterGuidePaymentSuccess } from '@dom/app/src/actions/analytics';
import { Container, Row, Col } from 'reactstrap';


import {
  StripeCheckoutForm,
  StripeLoaderContainer,
  WhitePanelLayout,
} from './imports';

import './guidePayment.scss';

import fetchInvoiceData from '../../api/fetchInvoiceData';
import GuidePaymentSummary from './GuidePaymentSummary';
import { usePromocode } from '@dom/components';

function GuidePayment(props) {
  const [lineItem, setLineItem] = useState(null);
  const [invoice, setInvoice] = useState(null);
  const { amount } = invoice || {};
  const {
    history,
    location: { search },
  } = props;
  const { invoiceId, guideId, porter } = parse(search);
  const buttonIdForTracking = porter ? 'porter-guide-payment-btn' : 'guide-payment-btn'

  const handlePaymentSuccess = () =>{
    const { history, porterGuidePaymentSuccess, guidePaymentSuccess } = props;
    if(porter) {
      porterGuidePaymentSuccess(amount);
    } else {
      guidePaymentSuccess(amount);
    }
    history.push(`payment/success${search}`);
  }

  const handlePaymentError = () => history.push(`payment/fail${search}`);

  useEffect(() => {
    async function awaitInvoiceData() {
      const { lineItems, invoice } = await fetchInvoiceData(invoiceId);

      setLineItem(lineItems[0]);
      setInvoice(invoice);
    }

    awaitInvoiceData();
  }, [invoiceId]);

  return (
    <Head title="Guide Payment">
      <PromocodeProvider>
        <Container>
          <Row>
            <Col lg="6" xs="12">
              <WhitePanelLayout className="payment-st">
                <StripeLoaderContainer>
                  <StripeWithPromocode
                    invoiceId={invoiceId}
                    onError={handlePaymentError}
                    onSuccess={handlePaymentSuccess}
                    buttonIdForTracking={buttonIdForTracking}
                  />
                </StripeLoaderContainer>
              </WhitePanelLayout>
            </Col>
            {invoice && (
              <GuidePaymentSummary
                invoice={invoice}
                lineItem={lineItem}
                guideId={guideId}
              />
            )}
          </Row>
        </Container>
      </PromocodeProvider>
    </Head>
  );
}

const ConnectedGuidePayment = connect(null,{ porterGuidePaymentSuccess, guidePaymentSuccess })(GuidePayment);

export default withRouter(ConnectedGuidePayment);

function StripeWithPromocode(props) {
  const [promocodeResponse] = usePromocode();

  return (
    <StripeCheckoutForm
      promocode={promocodeResponse && promocodeResponse.promocode}
      {...props}
    />
  );
};
